import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuditeePermissionDTO } from './../model/auditee-permission-dto';
import { CommonDTO } from 'app/model/common-dto';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root',
})
export class AuditorAuditeeDeptPermissionService {
  //url = environment.SERVER_URL;
  url: string;

  constructor(private httpClient: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  getPermissionRoleNDeptList(commonDTO: CommonDTO) {
    return this.httpClient.post(`${this.url}permission/dept/list`, commonDTO);
  }

  updateDeptWisePermission(auditeePermissionDTO: AuditeePermissionDTO) {
    return this.httpClient.post(`${this.url}permission/dept/update`, auditeePermissionDTO);
  }
}
